import "./App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import { LanguageProvider } from "./context/LanguageContext";
import AuthCallback from "./pages/AuthCallback";
import Home from "./pages/Home";
import CourseDetail from "./pages/CourseDetail";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Learn from "./pages/Learn";
import Admin from "./pages/Admin";
import PaymentSuccess from "./pages/PaymentSuccess";
import PaymentCancel from "./pages/PaymentCancel";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

function getVisitorId() {
  let id = localStorage.getItem("adj_visitor_id");
  if (!id) {
    id = window.crypto?.randomUUID ? window.crypto.randomUUID() : `${Date.now()}-${Math.random().toString(36).slice(2)}`;
    localStorage.setItem("adj_visitor_id", id);
  }
  return id;
}

async function getCountry() {
  const code = localStorage.getItem("adj_country");
  if (code) return { code, name: localStorage.getItem("adj_country_name") || code };
  try {
    const r = await fetch("https://get.geojs.io/v1/ip/country.json");
    const d = await r.json();
    if (d && d.country) {
      const name = d.name || d.country;
      localStorage.setItem("adj_country", d.country);
      localStorage.setItem("adj_country_name", name);
      return { code: d.country, name };
    }
  } catch (e) { /* ignore */ }
  return { code: null, name: null };
}

function AppRouter() {
  const location = useLocation();

  useEffect(() => {
    if (location.pathname.startsWith("/admin")) return;
    (async () => {
      const c = await getCountry();
      fetch(`${BACKEND_URL}/api/track/visit`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ visitor_id: getVisitorId(), path: location.pathname, country: c.code, country_name: c.name }),
      }).catch(() => {});
    })();
  }, [location.pathname]);

  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/course/:slug" element={<CourseDetail />} />
      <Route path="/login" element={<Login />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/learn/:slug" element={<Learn />} />
      <Route path="/admin" element={<Admin />} />
      <Route path="/payment/success" element={<PaymentSuccess />} />
      <Route path="/payment/cancel" element={<PaymentCancel />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <LanguageProvider>
        <AuthProvider>
          <Toaster position="top-center" theme="dark" richColors />
          <AppRouter />
        </AuthProvider>
      </LanguageProvider>
    </BrowserRouter>
  );
}

export default App;
